import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTagFilled = createSVG({
    children: (jsx("path", { d: "m21.261 12.699-.516.54-7.73 7.824q-.446.446-1.032.703a3.3 3.3 0 0 1-1.242.235q-.655 0-1.24-.235a3.4 3.4 0 0 1-1.032-.703L2.94 15.535a3.16 3.16 0 0 1-.938-2.297q0-1.335.938-2.272l8.012-8.013a3.2 3.2 0 0 1 2.788-.914l5.716.938q.704.117 1.195.632.516.493.61 1.219l.703 5.482q.094.68-.07 1.288-.164.585-.633 1.101M16.364 9.49q.798 0 1.335-.54.54-.562.54-1.335t-.54-1.311a1.78 1.78 0 0 0-1.336-.563q-.773 0-1.335.563-.539.54-.539 1.311 0 .774.54 1.335.563.54 1.335.54" })),
});

export { IconTagFilled };
